import React from "react";
import Title from "../components/header/Title";
import ComingSoon from "../components/common/ComingSoon";

const Roles: React.FC = () => {
  return (
    <React.Fragment>
      <Title title="Roles" subtitle="Managing the Roles" />
      <ComingSoon label="Roles" />
    </React.Fragment>
  );
};

export default Roles;
